import React, { useEffect, useState } from 'react';
import L from 'leaflet';
import { Marker, useMap } from 'react-leaflet';
import ReactDOMServer from 'react-dom/server';
import { MarkerContainer } from './styles';

function MarkerTollsPlaza({
  index,
  background,
  position,
  toll,
  handleClickTollsPlaza,
  markerRefCallback,
}) {
  const map = useMap();
  const [zoom, setZoom] = useState(() => map.getZoom());

  useEffect(() => {
    const handleZoomEnd = () => {
      setZoom(map.getZoom());
    };

    map.on('zoomend', handleZoomEnd);
    return () => {
      map.off('zoomend', handleZoomEnd);
    };
  }, [map]);

  let opacity = 1;
  if (zoom <= 6) {
    opacity = 0.6;
  } else if (zoom <= 9) {
    opacity = 0.95;
  } else {
    opacity = 1;
  }

  const customIcon = L.divIcon({
    className: 'toll-plaza-marker',
    html: ReactDOMServer.renderToString(
      <MarkerContainer background={background}>
        <span className="marker-index">{index + 1}</span>
      </MarkerContainer>
    ),
    iconSize: [24, 30],
    iconAnchor: [11, 30]
  });

  return (
    <Marker
      ref={markerRefCallback}
      pane="tollPlazaPane"
      position={position}
      icon={customIcon}
      opacity={opacity}
      zIndexOffset={1000}
      eventHandlers={{
        click: (event) => {
          event.originalEvent?.stopPropagation?.();
          handleClickTollsPlaza(toll, index, map);
        },
      }}
    />
  );
}

export default MarkerTollsPlaza;
